import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';

import styles from './Modal.module.css';

type IModalOverlayProps = IQATestableProps;

export function OzModalOverlay (props: IModalOverlayProps): ReactElement {
    const { 'data-testid': dataTestId = 'OzModalOverlay' }: IModalOverlayProps = props;

    return (
        <div
            className={classNames(
                `fixed z-10 flex flex-col justify-center items-center m-0 w-full h-full top-0 left-0 bg-gray-900 ${styles.modalMask}`)}
            data-testid={dataTestId}
        >
        </div>
    );
}
